module.exports = __webpack_public_path__ + "img/options1_2.4366d735.png";